import { render } from "./DedicateData.vue?vue&type=template&id=e28ad57c"
import script from "./DedicateData.vue?vue&type=script&lang=js"
export * from "./DedicateData.vue?vue&type=script&lang=js"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.19.3.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__